export const columnsWidths = {};
columnsWidths['original_name'] = '200px';
columnsWidths['account_name'] = '200px';
columnsWidths['subsidiary'] = '70px';
columnsWidths['geo'] = '60px';
columnsWidths['account_manager'] = '140px';
columnsWidths['account_manager_email'] = '180px';
columnsWidths['Segment'] = '240px';
columnsWidths['match_type'] = '150px';

columnsWidths['AccountManagerName'] = '180px';
columnsWidths['AccountManagerAlias'] = '180px';
columnsWidths['AccountTechnologyLeadName'] = '180px';
columnsWidths['AccountTechnologyLeadAlias'] = '180px';

columnsWidths['AccountTechnologyLeadName'] = '180px';
columnsWidths['AccountTechnologyLeadAlias'] = '180px';

columnsWidths['AccountTeamUnitManagerName'] = '180px';
columnsWidths['AccountTeamUnitManagerAlias'] = '180px';

columnsWidths['AzureSpecialistInfrastructureName'] = '180px';
columnsWidths['AzureSpecialistInfrastructureAlias'] = '180px';

columnsWidths['AzureSpecialistDataAndAIAlias'] = '180px';
columnsWidths['AzureSpecialistDataAndAIName'] = '180px';

columnsWidths['AzureSpecialistManagerInfrastructureName'] = '200px';
columnsWidths['AzureSpecialistManagerInfrastructureAlias'] = '200px';

columnsWidths['AzureSpecialistManagerDataAndAIAlias'] = '230px';
columnsWidths['AzureSpecialistManagerDataAndAIName'] = '230px';

columnsWidths['AzureInfraCSAAlias'] = '180px';
columnsWidths['AzureInfraCSAName'] = '180px';

columnsWidths['CSAMAlias'] = '180px';
columnsWidths['CSAMName'] = '180px';

columnsWidths['CSAMManagerAlias'] = '180px';
columnsWidths['CSAMManagerName'] = '180px';


/**
 * Transforms a snake_case string into a human-readable string with capitalization.
 * Handles specific exceptions for predefined strings.
 * @param {string} inputString - The string to transform (e.g., 'a_b_c').
 * @returns {string} - The transformed string based on rules and exceptions.
 */
export function returnParsedColumnName(inputString) {
    if (!inputString || typeof inputString !== 'string') {
        throw new Error('Invalid input string provided.');
    }

    // Define specific exceptions
    const exceptions = {
        'aws_account_name': 'Account name',
        'ms_account_name': 'Account name',
        'hq_id': 'HQ',
        'industry_id': 'Industry',
        'billing_country': 'Subsidiaries',
        'country_name': 'Country',
        'engaged_greenfield': 'Greenfield/Engaged',
        'geo': 'Region',
        'original_name': 'Searched Account Name',
        'searched_name': 'Account Name',
        'region_id': 'Region',
        'RegionName': 'Subsidiary',
        'microsoft_segment_group_id': 'Segment',
        'microsoft_subsegment_id': 'Sub Segment',
        'AccountManagerName': 'Account Manager Name',
        'AccountManagerAlias': 'Account Manager Email',
        'AccountTechnologyLeadName': 'ATS Name',
        'AccountTechnologyLeadAlias': 'ATS Email',
        'AccountTeamUnitManagerName': 'ATU Manager Name',
        'AccountTeamUnitManagerAlias': 'ATU Manager Email',
        'AzureSpecialistInfrastructureName': 'Core Specialist Name',
        'AzureSpecialistInfrastructureAlias': 'Core Specialist Email',
        'AzureSpecialistDataAndAIName': 'Data & AI Specialist Name',
        'AzureSpecialistDataAndAIAlias': 'Data & AI Specialist Email',
        'AzureSpecialistManagerInfrastructureName': 'Core Specialist Director Name',
        'AzureSpecialistManagerInfrastructureAlias': 'Core Specialist Director Email',
        'AzureSpecialistManagerDataAndAIName': 'Data & AI Specialist Director Name',
        'AzureSpecialistManagerDataAndAIAlias': 'Data & AI Specialist Director Email',
        'AzureInfraCSAName': 'ATCore CSA Name',
        'AzureInfraCSAAlias': 'ATCore CSA Email',
        'CSAMName': 'CSAM Name',
        'CSAMAlias': 'CSAM Email',
        'CSAMManagerName': 'CSAM Manager Name',
        'CSAMManagerAlias': 'CSAM Manager Email'
    };

    // Check if the input string matches any exception
    if (exceptions.hasOwnProperty(inputString)) {
        return exceptions[inputString];
    }

    // Default transformation: convert snake_case to a human-readable string
    return inputString
        .split('_') // Split the string by underscores
        .map((word, index) => 
            // Capitalize the first word, keep others lowercase
            index === 0 
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word.toLowerCase()
        )
        .join(' '); // Join the words with a space
}

